export default "__VITE_ASSET__DskJpBvE__"